const SPACE = ' ';
export const getCursorWord = (inputValue, cursorPosition = 0) => {
    const value = typeof inputValue === 'string' ? inputValue : String(inputValue);
    const cursor = cursorPosition !== null && cursorPosition !== void 0 ? cursorPosition : 0;
    let wordStart = Math.max(cursor, 0);
    while (wordStart > 0 && value[wordStart - 1] !== SPACE) {
        wordStart--;
    }
    let wordEnd = Math.min(cursor, value.length);
    while (wordEnd < value.length && value[wordEnd] !== SPACE) {
        wordEnd++;
    }
    const word = value.slice(wordStart, wordEnd).trim();
    return { word, cursorStart: wordStart, cursorEnd: wordEnd };
};
//# sourceMappingURL=get-cursor-word.js.map